"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferSlotsMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class OfferSlotsMapper {
    toDomain(result) {
        const offer = lodash_1.default.get(result, "data.offer");
        return {
            offer,
        };
    }
}
exports.OfferSlotsMapper = OfferSlotsMapper;
